export default __webpack_public_path__ + "static/media/tc.d8519cb2.svg";